package org.ksdfv.thelema.kxjs.json

import org.ksdfv.thelema.json.*
import kotlin.js.JSON

class JsJson: IJSON {
    override fun parseObject(text: String): IJsonObject =
        JsJsonObject(source = JSON.parse(text))

    override fun parseArray(text: String): IJsonArray =
        JsJsonArray(JSON.parse(text) as Array<dynamic>)

    override fun printArray(context: IJsonArray.() -> Unit): String =
        JSON.stringify(JsJsonArray().apply(context).toJSON())

    override fun printObject(context: IJsonObject.() -> Unit): String =
        JSON.stringify(JsJsonObject().apply(context).source)

    override fun printObject(json: IJsonObjectIO): String =
        JSON.stringify(JsJsonObject().apply { json.write(this) }.source)

    override fun printArray(json: IJsonArrayIO): String =
        JSON.stringify(JsJsonArray(json).toJSON())
}